import { useMemo } from 'react'
import type { VFC } from 'react'
import { translations } from '../NotificationTranslations'
import { populateNotificationTemplate } from './helpers'
import { textStyles } from './styles'
import { NotificationTextProps } from './types'

export const NotificationText: VFC<NotificationTextProps> = ({
  referencedObjects,
  supplementalText = '',
  theme = 'light',
  type,
}) => {
  const translationNodes = useMemo(() => {
    const typeArray = type.split('.')
    const notificationStringTemplate =
      translations[typeArray[0]][typeArray[1]] ?? ''
    return populateNotificationTemplate({
      notificationTemplate: notificationStringTemplate,
      referencedObjects,
      supplementalText,
      theme,
    })
  }, [referencedObjects, supplementalText, theme, type])

  return <div css={textStyles({ theme })}>{translationNodes}</div>
}
NotificationText.displayName = 'Satellite: NotificationText ← NotificationItem'
